import { makeStyles } from 'e100-react-components';
import { CONTROLS_Z_INDEX } from 'common/constants/styles';

import betaLabel from '../DesktopMapTypeSwitcher/betaLabel.svg';

import hereMap from './HereMap.svg';
import googleMap from './GoogleMap.svg';

export const useStyles = makeStyles(({
  spacing,
  shape
}) => ({
  container: {
    marginTop: spacing(2)
  },
  button: {
    width: spacing(5),
    height: spacing(5),
    minWidth: 0,
    padding: 0,
    zIndex: CONTROLS_Z_INDEX,
    '&:after': {
      content: '""',
      position: 'absolute',
      backgroundImage: `url(${betaLabel})`,
      right: -4,
      top: -11,
      width: spacing(3),
      height: spacing(3),
    }
  },
  buttonLabel: {
    height: '100%',
    padding: 2
  },
  hereIcon: {
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: '#0C3747',
    backgroundImage: `url(${hereMap})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%',
    borderRadius: shape.borderRadius
  },
  googleIcon: {
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: '#EDF0F2',
    backgroundImage: `url(${googleMap})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%',
    borderRadius: shape.borderRadius
  },
  list: {
    paddingBottom: 0
  },
  drawer: {
    borderTopLeftRadius: shape.borderRadius,
    borderTopRightRadius: shape.borderRadius
  }
}));